// extracted by mini-css-extract-plugin
export var active = "_33-9";
export var backButton = "_33-8";
export var clone = "_33-e";
export var collapseBar = "_33-k";
export var collapseMode = "_33-m";
export var collapsed = "_33-o";
export var dimmed = "_33-i";
export var dragHandle = "_33-c";
export var dropdownIcon = "_33-g";
export var expanding = "_33-n";
export var hidden = "_33-x";
export var iconContainer = "_33-q";
export var iconSwapper = "_33-w";
export var navItem = "_33-6";
export var navItemIcon = "_33-f";
export var navProfile = "_33-7";
export var notificationCountBadge = "_33-j";
export var notificationDot = "_33-r";
export var optionsContainer = "_33-h";
export var primaryNav = "_33-0";
export var primaryNavDivider = "_33-v";
export var primaryNavResizeHandle = "_33-2";
export var primaryNavResizing = "_33-1";
export var primaryNavTabSection = "_33-u";
export var primaryTab = "_33-p";
export var primaryTabIconBox = "_33-s";
export var secondaryNav = "_33-3";
export var selected = "_33-t";
export var settingsNav = "_33-4";
export var settingsNavItems = "_33-5";
export var show = "_33-d";
export var sideNav = "_33-l";
export var teamItem = "_33-a";
export var userProfileItem = "_33-b";